import { matchPath } from 'react-router-dom';

export const SKELETON_ROUTES = [
    // Brand
    '/brand/create/campaign/:id/overview',
    '/brand/campaign/dashboard/:id',
    '/brand/campaign/options/:id',
    '/brand/campaign/manage/:id',
    '/brand/campaign/contracts/:id/invite',
    '/brand/supplier',

    // Influencer
    '/influencer/explore',
    '/influencer/offer/declined',
    '/influencer/campaigns',
    '/influencer/campaign/:id/overview',

    // Agency
    '/agency/dashboard',
    '/agency/explore',
    '/agency/offers',
    '/agency/planner',
    '/agency/reporting',
    '/agency/invoices',
    '/agency/invoices/archive',
    '/agency/offer/declined',
    '/agency/campaign/:id/overview',

    // Settings
    '/settings/notifications',
    '/settings/users',
    '/settings/users/:id',
];

export const hasOwnSkeleton = (pathname: string) =>
    SKELETON_ROUTES.some(path => !!matchPath({ path, end: true }, pathname));
